module.exports = __webpack_public_path__ + "static/media/contactsBlue.4182371e.svg";